import React from 'react';
import { useStyletron } from 'baseui';
import type { InputOverrides } from 'baseui/input';
import { Input, SIZE as INPUT_SIZE } from 'baseui/input';
import { KIND as NOTIFICATION_KIND, Notification } from 'baseui/notification';
import { ParagraphSmall } from 'baseui/typography';
import { TEMPORAL_SCOPE } from '../../../../../modernization-common/relationships/constants';
import { NOTIFICATION_OVERRIDES } from '../../../../../modernization-common/relationships/overrides';
import type { TemporalScopeT } from '../../../../../modernization-common/relationships/types/relationship';
import { FrameFieldLabel } from './frame-field-label';
const errorFocusOverride: InputOverrides = {
  Root: {
    style: ({
      $error,
      $isFocused,
      $theme
    }) => $error && $isFocused ? {
      borderTopColor: $theme.colors.inputBorderError,
      borderRightColor: $theme.colors.inputBorderError,
      borderBottomColor: $theme.colors.inputBorderError,
      borderLeftColor: $theme.colors.inputBorderError
    } : {}
  }
};
type FrameClassificationFrameRangeInputsProps = {
  temporalScope: TemporalScopeT;
  startFrame?: number;
  endFrame?: number;
  startError?: string;
  endError?: string;
  onStartFrameChange: (value: number | undefined) => void;
  onEndFrameChange: (value: number | undefined) => void;
  startFrameTooltip: string;
  endFrameTooltip: string;
};
export const FrameClassificationFrameRangeInputs = ({
  temporalScope,
  startFrame,
  endFrame,
  startError,
  endError,
  onStartFrameChange,
  onEndFrameChange,
  startFrameTooltip,
  endFrameTooltip
}: FrameClassificationFrameRangeInputsProps) => {
  const [css, theme] = useStyletron();
  const isInterval = temporalScope === TEMPORAL_SCOPE.INTERVAL;
  const errorMessage = startError ?? endError;
  return <div>
      <div className={css({
      display: 'grid',
      gridTemplateColumns: isInterval ? '1fr 1fr' : '1fr',
      gap: theme.sizing.scale500
    })}>
        <div>
          <FrameFieldLabel label={isInterval ? 'Start frame' : 'Frame'} tooltip={startFrameTooltip} />
          <Input size={INPUT_SIZE.compact} type="number" value={startFrame === undefined ? '' : startFrame + 1} error={!!startError} overrides={errorFocusOverride} min={1} onChange={e => {
          const val = e.currentTarget.value;
          onStartFrameChange(val === '' ? undefined : Number(val) - 1);
        }} />
        </div>
        {isInterval && <div>
            <FrameFieldLabel label="End frame" tooltip={endFrameTooltip} />
            <Input size={INPUT_SIZE.compact} type="number" value={endFrame === undefined ? '' : endFrame + 1} error={!!endError} overrides={errorFocusOverride} min={1} onChange={e => {
          const val = e.currentTarget.value;
          onEndFrameChange(val === '' ? undefined : Number(val) - 1);
        }} />
          </div>}
      </div>
      {errorMessage && <Notification kind={NOTIFICATION_KIND.negative} overrides={NOTIFICATION_OVERRIDES} closeable={false}>
          <ParagraphSmall margin={0}>{errorMessage}</ParagraphSmall>
        </Notification>}
    </div>;
};